module.exports = __webpack_public_path__ + "static/media/market.11cfbf42.svg";